import { ContainersData } from '@interfaces/ral';

export const filterContainers = (containers: ContainersData) => Object.fromEntries(
    Object.entries(containers)
        .filter(([ _, { count, } ]) => count > 0)
);
